import { contentHeader } from "../../utils/header";
import { apiSlice } from "../apiSlice";

export const authUserApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    loginUser: builder.mutation({
      query: (postData) => ({
        url: "/auth/login/",
        method: "POST",
        body: postData,
        headers: {
          "Content-Type": "application/json",
        },
      }),
      invalidatesTags: ["User"],
    }),

    logoutUser: builder.mutation({
      query: (postData) => ({
        url: `/auth/logout/`,
        method: "POST",
        body: postData,
        headers: contentHeader(),
      }),
      invalidatesTags: ["User"],
    }),

    logoutAllUsers: builder.mutation({
      query: (postData) => ({
        url: `/auth/logoutall/`,
        method: "POST",
        body: postData,
        headers: {
          "Content-Type": "application/json",
        },
      }),
      invalidatesTags: ["User"],
    }),
  }),
});

export const {
  useLoginUserMutation,
  useLogoutAllUsersMutation,
  useLogoutUserMutation,
} = authUserApiSlice;
